import { useRouter } from 'next/router';
import { signIn, useSession } from 'next-auth/react';
import { FC, useEffect } from 'react';

import { useUserPermissions } from '@/hooks/use-user-permissions';
import { exportDynamic } from '@/utils/export';

export const SignIn: FC = () => {
    const router = useRouter();
    const { status } = useSession();
    const { callbackUrl } = router.query;
    const {
        isCampaignsAdmin,
        isMyBotsAdmin,
        isCallAnalyticsEnabled,
        isChatAnalyticsEnabled,
        isSmsAnalyticsEnabled,
    } = useUserPermissions();
    const hasAnalyticsRights =
        isCallAnalyticsEnabled ||
        isChatAnalyticsEnabled ||
        isSmsAnalyticsEnabled;

    useEffect(() => {
        const handleSignIn = async () => {
            if (status === 'unauthenticated') {
                const result = await signIn('keycloak', {
                    callbackUrl:
                        typeof callbackUrl === 'string' ? callbackUrl : '/bots',
                    redirect: false,
                });

                if (result?.error) {
                    console.error('Sign-in error:', result.error);
                }
            }
        };

        handleSignIn();
    }, [status, callbackUrl]);

    useEffect(() => {
        if (status === 'authenticated') {
            if (callbackUrl) {
                router.push(callbackUrl as string);
            } else if (isMyBotsAdmin) {
                router.push('/bots');
            } else if (isCampaignsAdmin) {
                router.push('/campaigns');
            } else if (hasAnalyticsRights) {
                router.push('/analytics');
            } else {
                router.push('/');
            }
        }
    }, [
        router,
        status,
        callbackUrl,
        isCampaignsAdmin,
        isMyBotsAdmin,
        hasAnalyticsRights,
    ]);
    return <></>;
};

export default exportDynamic(SignIn);
